<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV
                class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName"
            >
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-4">
                <date-range-picker
                    :minDate="minDate"
                    class="w-100"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true"
                    :always-show-calendars="false"
                    :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                    @showCustomRange="showCustomRangeCalendars = true"
                    @update="filterByDate"
                >
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label
                                class="input-group-text border-right-0"
                                for="serviceCategory"
                            >
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect
                                :value="selectedOutlet"
                                label="text"
                                track-by="id"
                                :options="outlet"
                                :searchable="false"
                                :show-labels="false"
                                openDirection="below"
                                @select="filterByOutlet"
                            >
                                <template
                                    slot="option"
                                    slot-scope="{ option }"
                                >{{ option.text }}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    id="DeliveryState"
                    v-model="deliveryState"
                    :options="DeliveryState"
                    :aria-describedby="ariaDescribedby"
                    name="DeliveryState"
                    @change="filterByState"
                ></b-form-radio-group>
            </b-form-group>
        </div>
        <br>

    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'deliveryFilter',
    components: {
        DateRangePicker
    },
    data() {
        let startDate = moment().startOf('month').toDate();
        let endDate = moment().endOf('month').toDate()
        return {
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            search: "",
            dateRange: { startDate, endDate },
            outlet: [{ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) }], selectedOutlet: { id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) },
            deliveryState: "all",
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: "",
        }
    },
    computed: {
        DeliveryState() {
            return [
                { text: this.$i18n.t('label.all', { 'item': '' }), value: "all" },
                { text: this.$i18n.t('label.new'), value: 'new' },
                { text: this.$i18n.t('label.delivery'), value: 'delivery' },
                { text: this.$i18n.t('label.packaged'), value: 'packaged' },
                { text: this.$i18n.t('label.delivered'), value: 'delivered' },
            ]
        }
    },
    watch: {
        "$i18n.locale"(val) {
            this.outlet = [{ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) }]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj => obj.id == b.id)[0]
        }
    },
    methods: {
        filterByOutlet(item) {
            this.selectedOutlet = item
            this.setFilter()
        },
        filterByDate(date) {
            this.dateRange = date
            this.setFilter()
        },
        filterByState(state) {
            this.deliveryState = state
            this.setFilter()
        },
        setFilter() {
            var data = {
                date: this.dateRange,
                search: this.search,
                outlet: this.selectedOutlet,
                deliveryState: this.deliveryState,
            }
            this.$emit('filterOrder', data)
        },
        setExportData(item) {
            this.exportData = item.exportData
            this.exportFields = item.exportFields
            this.exportFileName = item.exportFileName
            this.exportHeaders = item.exportHeaders
        },
    },
    mounted() {
        let $vm = this
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }

        $vm.setFilter()
    }
}
</script>